import React, { useState, useEffect } from 'react';
import { Form, Input, Button, notification, Select } from 'antd';
import axios from 'axios';

// Expresión regular para validar el correo electrónico
const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

const WinnerForm = ({ onSubmit,cart }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    bank: '', // Nuevo campo para el banco
  });

  const [loading, setLoading] = useState(false);
  const [banks, setBanks] = useState([]); // Estado para los bancos

  // Manejo de cambios en los campos del formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Función para obtener los bancos de la API
  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await axios.get(
          'https://api.mercadopago.com/v1/payment_methods/search?site_id=MCO&id=pse&public_key=APP_USR-a048e9ab-81f4-49ad-898a-02c50f55ec81'
        );
        const bankList = response.data.results[0].financial_institutions.map((bank) => ({
          label: bank.description,
          value: bank.id,
        }));
        setBanks(bankList); // Establecer la lista de bancos
      } catch (error) {
        notification.error({
          message: 'Error al cargar los bancos',
          description: 'No se pudieron cargar los bancos. Intenta nuevamente.',
        });
      }
    };

    fetchBanks(); // Llamar a la función para obtener los bancos
  }, []);

  // Función para enviar los datos del formulario y procesar el pago
  const handleSubmit = async (formData) => {
    setLoading(true); // Activar estado de carga
  
    try {
      // Enviar los datos del formulario al backend
      const response = await axios.post('https://appmagdalena.net/api/lottery/pago', {
        ...formData,
        number: cart, // Números seleccionados
      });
  
      if (response.data.success) {
        // Si la transacción fue exitosa, redirigir al usuario al sitio de pago de MercadoPago
        sendMail(formData,response.data.data.response.transaction_details.external_resource_url);
        setTimeout(() => {
          window.location.href = response.data.data.response.transaction_details.external_resource_url;
        }, 500); // 500ms de retraso
        // window.location.href = response.data.data.response.transaction_details.external_resource_url;  // Redirigir a la página de pago de MercadoPago

      } else {
        notification.error({
          message: 'Error al procesar el pago',
          description: 'Hubo un error al procesar tu pago. Inténtalo nuevamente.',
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error de conexión',
        description: 'No pudimos conectar con el servidor. Inténtalo nuevamente.',
      });
    } finally {
      setLoading(false); // Desactivar estado de carga
    }
  };
  

  const sendMail = async (formData,url) => {
  
    try {
      // Enviar los datos del formulario al backend
      const response = await axios.post('https://appmagdalena.net/api/lottery/sendmail', {
        ...formData,
        url: url, // Números seleccionados
        numbers: cart, // Números seleccionados
      });
  
      if (response.data.success) {
        // Si la transacción fue exitosa, redirigir al usuario al sitio de pago de MercadoPago // Redirigir a la página de pago de MercadoPago
      } else {
        notification.error({
          message: 'Error al procesar el email',
          description: 'Hubo un error al procesar tu pago. Inténtalo nuevamente.',
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error de conexión',
        description: 'No pudimos conectar con el servidor. Inténtalo nuevamente.',
      });
    } finally {
    }
  };
  
  

  return (
    <div style={{ padding: '20px', backgroundColor: 'white', borderRadius: '5px' }}>
      <h2>Formulario de Compra</h2>
      <Form onFinish={handleSubmit}>
        <Form.Item
          label="@deinstagram"
          name="name"
          rules={[{ required: true, message: 'Por favor ingresa tu @deinstagram' }]}
        >
          <Input
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Ingresa tu nombre"
          />
        </Form.Item>

        <Form.Item
          label="Teléfono"
          name="phone"
          rules={[
            { required: true, message: 'Por favor ingresa tu teléfono' },
            { len: 10, message: 'El teléfono debe tener 10 dígitos' },
            { pattern: /^[0-9]+$/, message: 'El teléfono solo puede contener números' },
          ]}
        >
          <Input
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Ingresa tu teléfono"
            maxLength={10}
            type="tel"
          />
        </Form.Item>

        <Form.Item
          label="Correo electrónico"
          name="email"
          rules={[
            { required: true, message: 'Por favor ingresa tu correo electrónico' },
            { pattern: emailPattern, message: 'Por favor ingresa un correo electrónico válido' },
          ]}
        >
          <Input
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Ingresa tu correo electrónico"
            type="email"
          />
        </Form.Item>

        {/* Campo para seleccionar el banco */}
        <Form.Item
          label="Banco"
          name="bank"
          rules={[{ required: true, message: 'Por favor selecciona tu banco' }]}
        >
          <Select
            name="bank"
            value={formData.bank}
            onChange={(value) => setFormData({ ...formData, bank: value })}
            placeholder="Selecciona tu banco"
          >
            {banks.map((bank) => (
              <Select.Option key={bank.value} value={bank.value}>
                {bank.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            block
            loading={loading} // Desactivar el botón mientras carga
          >
            Comprar
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default WinnerForm;
